import { D as t } from "./default-error-messages.constants-BvAz67KV.mjs";
import { a as i } from "./add-rhf-default-error-message-C9MkLfg3.mjs";
function r(e) {
  const { required: n } = e, d = {
    max: typeof e.max < "u" ? i(e.max, t.max) : void 0,
    maxLength: typeof e.maxLength < "u" ? i(e.maxLength, t.maxLength) : void 0,
    min: typeof e.min < "u" ? i(e.min, t.min) : void 0,
    minLength: typeof e.minLength < "u" ? i(e.minLength, t.minLength) : void 0,
    pattern: typeof e.pattern < "u" ? i(e.pattern, t.pattern) : void 0,
    required: typeof n < "u" ? i(
      typeof n == "string" ? !!n : n,
      typeof n == "string" ? n : t.required
    ) : void 0
  };
  return Object.keys(d).reduce((a, o) => (a[o] = d[o], a), {});
}
export {
  r as a
};
//# sourceMappingURL=add-rhf-default-error-messages-DzyaQrlA.mjs.map
